import React, { useState } from 'react';

import Modal from '../../components/modal/modal';
import { YoutubeBrandsIcon } from '../../shared/icons/icons';

import styles from './cms-youtube-video.scss';

interface CmsYoutubeVideoProps {
  embedUrl: string;
}

function CmsYoutubeVideo(props: CmsYoutubeVideoProps) {
  const { embedUrl } = props;

  const [showVideo, setShowVideo] = useState(false);

  if (!embedUrl) {
    return null;
  }

  const videoId = embedUrl.match(/embed\/([a-zA-Z-0-9]+)/)?.[1] || '';
  const thumbnailImageUrl = `https://i.ytimg.com/vi_webp/${videoId}/mqdefault.webp`;

  return (
    <>
      <button
        className={styles['play-video-button']}
        onClick={() => setShowVideo(true)}
        style={{
          backgroundImage: `url(${thumbnailImageUrl})`
        }}
        type="button"
      >
        <YoutubeBrandsIcon
          className={styles['youtube-icon']}
          data-testid="youtube-icon"
        />
      </button>
      <Modal isOpen={showVideo} onClose={() => setShowVideo(false)}>
        <div className={styles['video-container']}>
          <iframe
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            src={embedUrl}
            title="YouTube video player"
          />
        </div>
      </Modal>
    </>
  );
}

export default CmsYoutubeVideo;
